import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Outlet, useSearchParams} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import {useIntl} from 'react-intl';
import {getGroupExchangeUrl, getIsGroupExchangeTarget} from '@utils/groupTargetUtils';
import Loading from '../shared/Loading/Loading';
import LoginNews from './LoginNews/LoginNews';
import Logo from '../common/Logo/Logo';
import AuthPageHeader from '../common/AuthPageHeader/AuthPageHeader';
import SupportFooter from '../common/SupportFooter/SupportFooter';
import {
    selectIsAuthenticating,
    selectIsAuthenticated
} from './userSlice';
import {
    selectLastLoadedNewsLocale,
    selectLastLoadedNotificationsLocale,
    selectLocale,
    fetchNews,
    fetchNotifications,
    selectIsFetchingNews,
    selectIsFetchingNotifications
} from '../appSlice';
import './login.less';

export default function Login() {
    const intl = useIntl();
    const dispatch = useDispatch();
    const isAuthenticating = useSelector(selectIsAuthenticating);
    const isAuthenticated = useSelector(selectIsAuthenticated);
    const [searchParams] = useSearchParams();
    const locale = useSelector(selectLocale);
    const isFetchingNews = useSelector(selectIsFetchingNews);
    const isFetchingNotifications = useSelector(selectIsFetchingNotifications);
    const lastLoadedNewsLocale = useSelector(selectLastLoadedNewsLocale);
    const lastLoadedNotificationsLocale = useSelector(selectLastLoadedNotificationsLocale);

    useEffect(() => {
        if (!isAuthenticated) return;
        const target = searchParams.get('target');
        if (!getIsGroupExchangeTarget(target)) return;
        const exchangeUrl = getGroupExchangeUrl(target);
        if (exchangeUrl) {
            window.location.href = exchangeUrl;
        }
    }, [isAuthenticated, searchParams]);

    useEffect(() => {
        if (locale !== lastLoadedNewsLocale && !isFetchingNews) {
            dispatch(fetchNews());
        }
        if (locale !== lastLoadedNotificationsLocale && !isFetchingNotifications) {
            dispatch(fetchNotifications());
        }
    }, [locale]);

    return (
        <div className="login-page">
            <Loading isLoading={isAuthenticating} />
            <Helmet>
                <title alt="logo">
                    {`${intl.formatMessage({id: 'esl.generic.login', defaultMessage: ''})} -
                    ${intl.formatMessage({id: 'page.title', defaultMessage: ''})}`}
                </title>
            </Helmet>
            <div className="login-form-container">
                <AuthPageHeader />
                <div className="form-wrapper">
                    <div className="logo-container">
                        <Logo isRedirectDisabled />
                    </div>
                    <Outlet />
                    <SupportFooter />
                </div>
            </div>
            <LoginNews />
        </div>
    );
}
